// @flow
import CSSSticky from './css-sticky';

export default CSSSticky;
